import Card from "./Card"
import Container from "./Container"
import Page from "./Page"

const Template = { Card, Page, Container }
export default Template
